import DragOverPanel from '../ScreenComponents/DragOverPanel';

export function doActualWrap(sortedCardItemKeys, itemInfoPath, intermediate, itemEdited, setItemEdited, currentList, organicChanges, itemType, cardPieces, actualWidth){
    var cardPiecesOut = []; 
    var intermediatePath = itemInfoPath.concat([intermediate]);
    var isJustAfter = false;
    sortedCardItemKeys.forEach((aKey, index)=>{

      var alertPath = intermediatePath.concat([aKey]);
      if (alertPath.join(' ').indexOf(itemEdited.path.join(' ')) === -1){
        var isOn = false;
        if (itemEdited.path.join(' ') !== alertPath.join(' ')){
          if (itemEdited.d){
            if (!isJustAfter){
              isOn = true;
            }else{
              isJustAfter = false;
            }
          }
        }
        cardPiecesOut.push(<DragOverPanel key={'kk'+index} isOn={isOn} actualWidth={actualWidth} itemEdited={itemEdited} setItemEdited={setItemEdited} aKey={aKey} intermediatePath={intermediatePath} currentList={currentList} organicChanges={organicChanges} itemType={itemType}/>)
      }else{
        isJustAfter = true;
      }

      cardPiecesOut.push(cardPieces[index]);
    })

    if (!isJustAfter){
      var isOn2 = false;
      if (itemEdited.d){
        isOn2 = true;
      }
      cardPiecesOut.push(<DragOverPanel key={'kkX'} isOn={isOn2} actualWidth={actualWidth} itemEdited={itemEdited} setItemEdited={setItemEdited} aKey={false} intermediatePath={intermediatePath} currentList={currentList} organicChanges={organicChanges} itemType={itemType}/>)

    }


    return cardPiecesOut;

}
